import React from "react";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {FlipIconRTL} from "./FlipIconRTL";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import {getLabel} from "../localization/MainLocalization";



export const CustomBreadcrumbs = props => {
    let page = "nothing";
    const data = {
        dashboard: {
            path: `/dashboard`,
            tag: "Dashboard",
            parent: null
        },
        import_data: {
            path: `/import-data`,
            tag: "Import data",
            parent: null
        },
        actions: {
            path: `/actions`,
            tag: "Actions",
            parent: null
        },
        view_class_attendance: {
            path: `/actions/view-class-attendance`,
            tag: "View class attendance entity error",
            parent: "actions"
        },
    }

    for (let key in data) {
        if ([props.match.url, props.match.url.slice(0, -1)].includes(data[key].path)) {
            page = key;
        }
    }


    const getBreadcrumbs = (value, index) => {
        let parent = ""
        if (data[value].parent !== null) {
            parent = getBreadcrumbs(data[value].parent, index + 1);
        }
        return (
            <Breadcrumbs separator={<FlipIconRTL><NavigateNextIcon fontSize="large"/></FlipIconRTL>}>

                {parent}
                <Button key={index} component={Link} className="font-weight-bold" size="large" color="inherit" to={data[value].path}
                        disabled={index === 0 || data[value].disabled}>
                    {data[value].tag}
                </Button>
            </Breadcrumbs>
        )

    }

    return getBreadcrumbs(page, 0);

}
